exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pgt-find{align-items:center;background:#f2f2f2;display:grid;grid-gap:10px;grid-template-columns:repeat(3,1fr) 100px;margin-bottom:25px;padding:10px;width:100%\n}\n.pgt-find input,.pgt-find select{margin:0\n}\n.pgt__controls{align-items:center;display:flex;justify-content:flex-start;margin-bottom:25px;width:100%\n}\n.pgt__controls>*{display:inline-block;margin-right:20px\n}\n.pgt__controls input,.pgt__controls select{margin:0;width:auto\n}\n.pgt__controls .button{margin:0\n}", ""]);

// exports
